import styled from 'react-emotion';
import { withTheme } from 'emotion-theming';

export const UploadButtonWrapper = withTheme(styled.div`
  ${({ theme: { color } }) => `
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px dashed ${color.grey2};
    border-radius: 4px;
    height: 90px;
  `}
`);
